(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('totalGivenLocalTokensPerDayReportController', totalGivenLocalTokensPerDayReportController);

  /** @ngInject */
  function totalGivenLocalTokensPerDayReportController($scope, $translate, reportExportUtil, exportToCsv, totalGivenLocalTokensPerDayReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new totalGivenLocalTokensPerDayReportViewModel();
    vm.exportToCsv = exportCsv;
    vm.namingData = 'TOKENS_TITLE';

    init();

    function init() {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy() {
      vm.report.destroy();
    }

    function exportCsv() {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant('DATE'),
        vm.report.chart.data,
        reportExportUtil.ValueFormattersEnum.DATE,
        reportExportUtil.ValueFormattersEnum.NUMBER, vm.namingData);

      exportToCsv.export(jsonArrayForExport,
        $translate.instant('TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY'),
        true);
    }

  }
})();
